import { connect } from 'react-redux';
import User from 'shared/user';
import { getUserAuthProfile } from 'web/store/modules/user';
import { getCompanyId } from 'web/store/modules/company';

const mapStateToProps = state => ({
  profile: getUserAuthProfile(state),
  companyId: getCompanyId(state),
});

const mapDispatchToProps = null;

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { profile, companyId } = stateProps;

  const currentUser = new User(profile);
  const userIsAuthorized = args => currentUser.isAuthorized({ companyId, ...args });

  return {
    userIsAuthorized,
    ...ownProps,
  };
};

export default Component => (
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
  )(Component)
);
